import { gql, useMutation } from '@apollo/client';

import type { UpsertVehicleMutation, UpsertVehicleMutationVariables } from './__generated__/useUpsertVehicle.gql';

const UPSERT_VEHICLE = gql`
  mutation UpsertVehicle($input: UpsertVehicleInput!) {
    upsertVehicle(input: $input) {
      id
      ownership
      ownershipOther
      year
      make
      model
    }
  }
`;

/**
 * Creates or updates a family `Vehicle`. With `input.vehicleId` Apollo's
 * normalized cache merges the returned fields automatically; without it, the
 * mutation refetches `GetOnboardingVehicles` so the new row appears in the
 * list query.
 */
export const useUpsertVehicle = () => {
  return useMutation<UpsertVehicleMutation, UpsertVehicleMutationVariables>(UPSERT_VEHICLE, {
    refetchQueries: ['GetOnboardingVehicles'],
  });
};
